module.exports = __webpack_public_path__ + "img/pousada-pequi.d4c9d7b4.jpg";